import { createSelector } from "reselect";
import {
  filterDefaultRoutes,
  filterDriverRoutes,
  findSectionRoute,
} from "../../models/routes";

export const getRoutesList = (state) => state.routesData.routes;

export const getRoutesFilters = (state) => state.routesData.filters;

export const getRouteDetailId = (state) => state.routesData.routeDetailId;

export const getRouteDepotStats = (state) => state.routesData.depotStats;

export const getDefaultRoutes = createSelector(
  getRoutesList,
  (_, sectionId) => sectionId,
  filterDefaultRoutes
);

export const getDriverRoutes = createSelector(
  getRoutesList,
  filterDriverRoutes
);

export const getRouteById = createSelector(
  getRoutesList,
  getRouteDetailId,
  (routes, current) => routes[current]
);

export const getSectionRoute = createSelector(
  getRoutesList,
  (_, sectiondId) => sectiondId,
  findSectionRoute
);
